import { SeekPassIconVerified } from '@seek/certsy-ui';
import { Text, Inline, Column, Columns, Box } from 'braid-design-system';

export const Status = ({
  label,
  isVerified,
  text,
  fontStyle,
}: {
  label: string;
  isVerified?: boolean;
  text: string;
  fontStyle?: 'normal' | 'italic';
}) => (
  <Columns space="small" collapseBelow="tablet">
    <Column width="1/3">
      <Inline alignY="center" space="xxsmall">
        <Text size="small">
          {label} {isVerified && <SeekPassIconVerified />}
        </Text>
      </Inline>
    </Column>
    <Column>
      <Inline alignY="center" space="xxsmall">
        <Text size="small">
          {fontStyle === 'italic' ? (
            <Box style={{ fontStyle: 'italic' }}>{text}</Box>
          ) : (
            text
          )}
        </Text>
      </Inline>
    </Column>
  </Columns>
);
